"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.showPreviewBoxWithDataFromImage = exports.PreviewBox = void 0;
exports.renderPreviewBox = renderPreviewBox;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const react_1 = require("react");
const VideoPlayer_1 = require("../VideoPlayer");
const PreviewBoxPopup_1 = require("./PreviewBoxPopup");
class PreviewBox extends react_1.Component {
    constructor(props) {
        super(props);
        this.closePopup = () => {
            this.setState({
                isPopupOpened: false,
            }, () => {
                this.props.closePopup();
            });
        };
        const startTime = +app_1.UrlService.GetQueryValueFromUrl('t', props.videoUrl) || 0;
        this.state = {
            isPopupOpened: props.isPopupOpened,
            reactDOMRenderId: props.reactDOMRenderId,
            playerVars: { start: startTime },
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (props.reactDOMRenderId && props.reactDOMRenderId !== state.reactDOMRenderId) {
            return {
                isPopupOpened: props.isPopupOpened,
                reactDOMRenderId: props.reactDOMRenderId,
            };
        }
        else if (!props.reactDOMRenderId && props.isPopupOpened !== state.isPopupOpened) {
            return {
                isPopupOpened: props.isPopupOpened,
            };
        }
        return null;
    }
    render() {
        const { videoUrl, popupArialLabel, closeButtonArialLabel, container } = this.props;
        return ((0, jsx_runtime_1.jsx)(PreviewBoxPopup_1.default, { container: container, open: this.state.isPopupOpened, popupAriaLabel: popupArialLabel, closeButtonAriaLabel: closeButtonArialLabel, onClose: this.closePopup, children: (0, jsx_runtime_1.jsx)("div", { className: "video-modal group aspect-video overflow-hidden rounded-3xl", children: (0, jsx_runtime_1.jsx)(VideoPlayer_1.default, { videoUrl: videoUrl, onVideoEvent: app_1.GTM.iframeYoutubeVideo, cookieCategoriesAcceptance: app_1.UtilService.getCookieCategoriesAcceptance(), playerVars: this.state.playerVars }) }) }));
    }
}
exports.PreviewBox = PreviewBox;
const previewBoxId = 'preview-box-element';
let previewBoxContainer = document.getElementById(previewBoxId);
function closePopup() {
    app_1.overlayService.disableBodyScrollLock();
}
function renderPreviewBox(url, popupArialLabel = '', closeButtonArialLabel = '') {
    app_1.overlayService.enableBodyScrollLock();
    if (!previewBoxContainer) {
        const previewBox = document.createElement('div');
        previewBox.id = previewBoxId;
        document.body.appendChild(previewBox);
        previewBoxContainer = previewBox;
    }
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(PreviewBox, { videoUrl: url, isPopupOpened: true, closePopup: closePopup, popupArialLabel: popupArialLabel, closeButtonArialLabel: closeButtonArialLabel, reactDOMRenderId: app_1.DateService.getTimestamp(), container: previewBoxContainer }), previewBoxContainer);
}
const showPreviewBoxWithDataFromImage = (event, el, isAnchor = false) => {
    const url = !isAnchor ? el.getAttribute('data-url') : el.getAttribute('href');
    const popupArialLabel = el.getAttribute('data-popup-aria-label');
    const closeButtonArialLabel = el.getAttribute('data-close-button-aria-label');
    if (app_1.VideoService.checkIsValidVideo(url)) {
        event.preventDefault();
        renderPreviewBox(url, popupArialLabel, closeButtonArialLabel);
    }
};
exports.showPreviewBoxWithDataFromImage = showPreviewBoxWithDataFromImage;
